import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function createCategory(data) {
  return Axios({
    url: `${baseUrl()}/category`,
    method: "POST",
    data: data,
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
